<template>
<div>
  <div class="h-100" ref="fadeWhenModelOpen">
    <div class="d-inline-flex w-100" style="height:50px;">
        <div class="justify-content-start">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb comm-settings-top-nav m-0">
                  <li>
                      <back-button  v-on:click.native="changeComponent('show-user-groups')" style="position: relative;bottom: 7px;inset-inline-start:5px;"></back-button>
                  </li>
                    <li v-if="seletedUserGroupName" class="breadcrumb-item active-text-nav-bar" aria-current="page">{{seletedUserGroupName}}</li>
                </ol>
            </nav>
        </div>
        </div>
    <nav class="navbar navbar-expand-lg p-0">
        <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
            <div class="navbar-nav w-100 top-nav-bar">
                <a class="nav-item nav-link w-50" v-on:click="selectedUserGroupComponent = 'user-group-info';" :class='(selectedUserGroupComponent === "user-group-info")?"active":"inactive"'>Basic Info<span class="sr-only">(current)</span></a>
                <a class="nav-item nav-link w-50" v-on:click="selectedUserGroupComponent = 'user-group-privileges'" :class='(selectedUserGroupComponent === "user-group-privileges")?"active":"inactive"'>Privileges</a>
                <a class="nav-item nav-link w-50" v-on:click="selectedUserGroupComponent = 'user-group-bin-permissions'" :class='(selectedUserGroupComponent === "user-group-bin-permissions")?"active":"inactive"'>Bin Permissions</a>
                <a class="nav-item nav-link w-50" v-on:click="selectedUserGroupComponent ='user-group-catalog-permissions'" :class='(selectedUserGroupComponent === "user-group-catalog-permissions")?"active":"inactive"'>Catalog Permissions</a>
                <a class="nav-item nav-link w-50" v-on:click="selectedUserGroupComponent = 'user-group-Retrieval-settings'" :class='(selectedUserGroupComponent === "user-group-Retrieval-settings")?"active":"inactive"'>Retrieval Settings</a>
            </div>
        </div>
    </nav>
    <template v-if="selectedUserGroupComponent == 'user-group-info'">
      <div class="height-set">
        <table class="table users-basic-info-table" style="background: transparent">
          <thead style="color: #eee">
            <tr>
              <th scope="col" style="width: 11%"></th>
              <th scope="col" style="width: 80%"></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="key-div">{{$t('Group Name')}}</td>
              <td class="value-div d-inline-flex float-left m-0" style="padding:10px 0px !important">
                <div class="w-100 d-inline-flex">
                  <input
                      minlength="3"
                      type="text"
                      v-model="userGroupInfo.group_name"
                      class="rounded text-light comm-input-field-style"
                      id="group_name"
                      style="padding-inline-start:5px;"
                      placeholder="Enter group name"
                    />
                </div>
              </td>
            </tr>
            <tr v-if="globalSettingsFromStartup.enable_department" >
              <td class="key-div">{{globalSettingsFromStartup.department_alias &&  globalSettingsFromStartup.department_alias.alias_name?globalSettingsFromStartup.department_alias.alias_name:"Department"}}</td>
              <td class="value-div d-flex m-0" style="display:flex !important;flex-direction:column;padding: 10px 0px !important;">
                <departmentsCommonComponent :isMultiselectDropdown='true' :selectedProject="selectedDepartments" @updateSelectedDepartments="updateSelectedDepartments"></departmentsCommonComponent>
                <span @click="openManageDepartment = true" class="manage-department-styles">Manage {{globalSettingsFromStartup.department_alias &&  globalSettingsFromStartup.department_alias.alias_name?globalSettingsFromStartup.department_alias.alias_name:"Department"}}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="group-members">
        <!-- <div class="search-bar-comm-style pt-2 col-md-9" style="display: block;">
            <input
              type="text"
              v-model="searchUser"
              class="rounded text-light search-bar"
              placeholder="Search user"/>
        </div> -->
        <div style="overflow:auto;height:90%" class="w-100">
                <div style="flex-wrap: wrap;justify-content: start;display: inline-flex;padding:14px;float:inline-start">
                  <div style="margin: 0px 0px 0px 19px;width: 100px; position: relative; margin: 3px;" v-on:click="addUserFromBrowse()"><div class="add-user-icon-wrapper"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-person-plus-fill" viewBox="0 0 16 16">
                      <path d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                      <path fill-rule="evenodd" d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"/>
                    </svg></div>
                    <div>{{$t('Add user')}}</div>
                    </div>
                    <div v-for="tagId in filteredUsers" :key="tagId" class="comm-tags-class" style="width:100px;position:relative;margin: 3px 3px;">
                      <div v-if="Object.keys(selctedserNameIdList[tagId]).includes('profile_image') && !['undefined',null].includes(selctedserNameIdList[tagId].profile_image) && selctedserNameIdList[tagId].profile_image" class='user-name-or-image'>
                            <img :title="selctedserNameIdList[tagId].username" :src="getProxyConvertedURL(selctedserNameIdList[tagId].profile_image)" @error="replaceWithUserIcon($event,selctedserNameIdList[tagId].username)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px">
                      </div>
                      <div v-else class="user-name-or-image" :title="selctedserNameIdList[tagId].username" :style="style(selctedserNameIdList[tagId].username)" >{{selctedserNameIdList[tagId].username.split("")[0]}}</div>
                      <div style="text-align:center;word-break: break-all;">{{selctedserNameIdList[tagId].username}}</div>
                      <cancel-icon class="delete-user-icon" @click.native="deleteUserFromGroup(tagId)"></cancel-icon>
                    </div>
                </div>   
          </div>
        </div>
      </div>
    </template>
  </div>
    <user-group-privileges v-show="selectedUserGroupComponent == 'user-group-privileges'" v-bind="currentProperties" :newUserGroup=true ref="newUserGroupPrivileges"></user-group-privileges>
    <user-group-bin-permissions v-show="selectedUserGroupComponent == 'user-group-bin-permissions'" v-bind="currentProperties" :newUserGroup=true ref="newUserGroupBinPermissions"></user-group-bin-permissions>
    <user-group-catalog-permissions v-show="selectedUserGroupComponent == 'user-group-catalog-permissions'" v-bind="currentProperties" :newUserGroup=true ref="newUserGroupCatalogPermissions"></user-group-catalog-permissions>
    <user-group-Retrieval-settings v-if="selectedUserGroupComponent == 'user-group-Retrieval-settings'" v-bind="currentProperties" :newUserGroup=true ref="newUserGroupRetrievalSettings"></user-group-Retrieval-settings>
    <div class="primary-btn-style">
      <button
        @click="addUserGroup(userGroupInfo)"
        class="btn btn-outline-primary"
        data-v-198e7d7f=""
        style="position: relative; float: inline-end; inset-inline-end :0"
      >
        {{$t('Save')}}
      </button>
      <button class="btn btn-outline-secondary mr-3" data-dismiss="modal"  v-on:click="changeComponent('show-user-groups')">{{$t('Cancel')}}</button>
    </div>
        <ManageDepartments v-if="openManageDepartment" @close="openManageDepartment = false"></ManageDepartments>
        <add-user-browse v-if='isUsersBrowseEnabled' :selectedUserGroupID='selectedUserGroupID'  :isEditGroup='false' :userNameIdMap='selctedserNameIdList' :selectedIds='selectedUserGroupInfo.user_list' @close='handleUserSelection'></add-user-browse>
  </div>
</template>

<script>
import {mapActions, mapMutations} from "vuex"
import Utils from "../../components.utils.js";
import UserPrivileges from "../userGroups/UserGroupPrivileges.vue"
import BinPermissions from "../userGroups/UserGroupBinPermissions.vue"
import CatalogPermissions from "../userGroups/UserGroupCatalogPermissions.vue"
import CancelIcon from "../core/InlineCancelField.vue";
import GroupRetrievalSettings from "./GroupRetrieveConfiguration.vue"
import BackButton from "../core/backButton.vue";
import AddUserFromBrowse from "./AddUserFromBrowse.vue";
import {NotifierConstants} from "../../components.constants.js";
import ManageDepartments from "../users/ManageDepartments.vue";
import departmentsCommonComponent from "../miscellaneous/departmentsCommonComponent.vue";

export default {
  components:{
    "cancel-icon":CancelIcon,
    "user-group-privileges": UserPrivileges,
    "user-group-bin-permissions": BinPermissions,
    "user-group-catalog-permissions": CatalogPermissions,
    "user-group-Retrieval-settings": GroupRetrievalSettings,
    "back-button":BackButton,
    "add-user-browse":AddUserFromBrowse,
    ManageDepartments,
    departmentsCommonComponent
  },
  data() {
    return {
      userGroupInfo: {},
      newUserGroupData:{},
      selectedUserGroupComponent:'user-group-info',
      selctedserNameIdList:{},
      selectedUserIdList:[],
      isUsersBrowseEnabled:false,
      userList: [],
      userListFromAutocomplete:[],
      usernameWithIdList:[],
      selectedUserGroupInfo:{},
      searchKey:"",
      searchUser:null,
      openManageDepartment:false,
      departmentsList:[],
      selectedDepartments:null
    };
  },
  emits: ["changeSelectedComponent"],
  computed:{
      globalSettingsFromStartup:{
        get(){
          return this.$store.state.startUpData.startUpDataDetails;
        }
      },
      currentProperties() {
        return { selectedUserGroupID: this.newUserGroupData._id };
      },
      filteredUsers() {
        if(this.searchUser != null){
          if (!this.selectedUserIdList.length) {
              return [];
            }
            return this.selectedUserIdList.filter((item) => {
              const userName = this.selctedserNameIdList[item].toLowerCase();
              const searchTerm = this.searchUser.toLowerCase();
              return userName.includes(searchTerm);
            });
          }else{
            return this.selectedUserIdList;
          }
        },
    },
  methods : {
    updateSelectedDepartments(values){
      this.selectedDepartments = values;
    },
    style(name){
      let style = {
        'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
        'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
      }
      return style
    },
    selectProjects(selectedOption){
      let index = this.departmentsList.findIndex(item => item._id == selectedOption._id);
      if(index > -1){
          this.departmentsList[index].checked = true;
      }
    },
    makeProjectFilterCheckboxAction(option){
      if(this.selectedDepartments)
      return this.selectedDepartments.some((op) => op._id === option._id);
    },
    removeSelectetProjectFilterFromSelectedList(selectedOption){
        this.selectedDepartments = this.selectedDepartments.filter(e => e._id != selectedOption._id);
    },
    getProfileImageOfUser(image){
        let defaultImage = Utils.getNoThumbnailImg()
        let profileImageTag = '<img src='+this.getProxyConvertedURL(image)+' onerror="this.src='+defaultImage+'; this.onerror = null"  style="width:100%;height:100%;border-radius:6px">'
        return profileImageTag;
    },
    replaceWithUserIcon(e){
        e.target.onerror = null
        e.target.src = Utils.getNoThumbnailImg();
    },
    handleUserSelection(UserIds, userIdNameMap){
      this.isUsersBrowseEnabled = false;
      this.$refs.fadeWhenModelOpen.style.opacity = 1;
      this.selctedserNameIdList = {...this.selctedserNameIdList,...userIdNameMap};
      let i= 0;
      while(i <UserIds.length){
        if(this.selectedUserIdList.indexOf(UserIds[i]) < 0){
          this.selectedUserIdList.push(UserIds[i])
        }
        i++
      }
      this.isUsersBrowseEnabled = false
    },
    deleteUserFromGroup(userId){
      this.selectedUserIdList.splice(this.selectedUserIdList.indexOf(userId),1)
    },
    addUserFromBrowse(){
      this.isUsersBrowseEnabled = true;
      this.$refs.fadeWhenModelOpen.style.opacity = 0.2;
    },
    changeComponent(comp){
            this.$emit("changeSelectedComponent", comp);
            let enableAddGroupButton = false
            if(this.tableType == 'show-user-groups'){
                    this.$emit("changeSelectedComponent",comp)
                    this.$refs.userGroupRef.changeSelectedComponent(comp)
                if(comp == "show-user-groups"){
                    enableAddGroupButton = true
                }else if(comp == "user-group-info"){
                    enableAddGroupButton = true
                }
            }
            this.showUserGroupAddButton = enableAddGroupButton
      },
    getOnlyIdsArr(arrayOfDictionaries){
        return arrayOfDictionaries.map(item => item._id);
    },
    addUserGroup() {
      if (
        typeof this.userGroupInfo.group_name == "undefined" ||
        this.userGroupInfo.group_name.trim().length <= 0
      ) {
        alert("Please add valid group name. ");
        this.selectedUserGroupComponent = 'user-group-info'
        document.getElementById("group_name").focus();
        return;
      }
      this.userGroupInfo.user_list = this.selectedUserIdList
      if (
        typeof this.userGroupInfo.user_list == "undefined" ||
        this.userGroupInfo.user_list.length <= 0
      ) {
        alert("Please add user(s) to the group. ");
        this.selectedUserGroupComponent = 'user-group-info'
        document.getElementById("user_list").focus();
        return;
      }
      if(this.$refs.newUserGroupPrivileges){
      this.userGroupInfo["access_control"] = {
        privileges:this.$refs.newUserGroupPrivileges.getUserGroupPrivileges(),
        bins:this.$refs.newUserGroupBinPermissions.getUserGroupBinPermissions(),
        catalogs:this.$refs.newUserGroupCatalogPermissions.getUserGroupCatalogPermissions(),
      }
      }else{
        this.userGroupInfo["access_control"] = {privileges:[],bins:[], catalogs:[]}
      }
      if(this.$refs.newUserGroupRetrievalSettings){
        let retrievePathInfo = this.$refs.newUserGroupRetrievalSettings.getRetrievalConfigurations();
        this.userGroupInforetrieval = retrievePathInfo
        this.userGroupInfo["access_control"]["retrieval"] = retrievePathInfo;
      }
      if(this.selectedDepartments && this.selectedDepartments.length > 0)this.userGroupInfo['department'] = this.getOnlyIdsArr(this.selectedDepartments);
      this.addNewUserGroup(this.userGroupInfo).then((data) => {
        if (Utils.isAcceptedStatusCode(data.statusCode)) {
          this.$toast.success(data.message);
          this.newUserGroupData = data;
          this.$emit("changeSelectedComponent", "show-user-groups");
        } else {
          this.$toast.error(data.message);
        }
      });
    },
    handleUsersNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      let userInfo = notification.message
      if(userInfo){
        if([NotifierConstants.userRemovedNotification].includes(notification.message_type)){
          if(this.selectedUserIdList.includes(userInfo._id)){
            this.selectedUserIdList.splice(this.selectedUserIdList.indexOf(userInfo._id), 1)
          }
        }
      }
    },
    registerforWebsocketNotifications(){
      this.addWSEventListener({
            eventname:[NotifierConstants.userRemovedNotification],
            callback:this.handleUsersNotification,
            parent:"AddUserGroup"})
    },
    unRegisterforWebsocketNotifications(){
      this.removeWSEventListener({
            eventname:[NotifierConstants.userRemovedNotification],
            callback:this.handleUsersNotification,
            parent:"AddUserGroup"})
    },
    ...mapActions("userGroups",["addNewUserGroup"]),
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
    ...mapActions("miscellaneous", ["getDepartments","createDepartment","updateDepartmentInfo","deleteDepartment"]),
  },
  mounted(){
    document.getElementById("group_name").focus();
  },
  created(){
    this.getDepartments().then((data) => {
      this.departmentsList = data.department;
    }) 
    this.registerforWebsocketNotifications()
  },
  beforeDestroy(){
    this.unRegisterforWebsocketNotifications()
  }
};
</script>

<style scoped lang="scss">
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;

.search-bar{
  background: $primary-background!important;
  height:40px;
  width: 250px !important;
  float: inline-start;
  padding-inline-start: 12px;
  padding-bottom: 2px;
}

.height-set{
  height: calc(100vh - 205px);
  background: $primary-background;
  .group-name{
    text-align: start;
    padding:16px 3%;
    font-size:27px;
    display:flex;
  }
  .group-members{
    height: calc(100% - 138px);
  }
}

.editIcon {
    margin-inline-start: 9px;
    font-size: 17px;
    margin-top: 4px
}

.comm-input-field-style{
    background: $primary-background!important;
    height:40px;
    width: 100% !important;
    float: inline-start;
    padding-inline-start: 12px;
    padding-bottom: 2px;
    border: $border-color !important;
}

.search-bar-comm-style{
  padding-inline-start:3%;
  height:60px;
}

#contact_number_input::-webkit-outer-spin-button,
#contact_number_input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.users-basic-info-table {
  tbody {
    margin: 10px;
    .key-div {
      text-align: start;
      color: $dull-text-color;
      padding-inline-start: 3% !important;
    }
    .value-div {
      text-align: start;
      margin-inline-start: 10px;
      width: 40%;
      font-weight: 500;
      input,select{
        padding-inline-start:4px;
      }
    }
  }
}

.activeclass {
  color: $active-blue;
}

table {
  background: transparent;
  thead {
    th {
      color: $dull-text-color;
      border-top: none !important;
      border-bottom: none !important;
    }
  }
  tbody {
    color: $text-color;
    td {
      border-top: none !important;
    }
  }
}

.btn {
  font-size: 14px !important;
  height: 100%;
}

.custom-control-label::before {
  background-color: $primary-background;
}

table.users-basic-info-table .editIcon {
  visibility: hidden;
}
table.users-basic-info-table td.value-div:hover .editIcon {
  visibility: visible;
}

.disablefield {
  border: none !important;
  pointer-events: none;
}

.force-logout {
  position: relative;
  inset-inline-start:5px;
  bottom: 4px;
}
.force-logout:hover {
  text-decoration: underline;
}
.activestatus {
  color: $active-green-color !important;
}
.validationmessage {
  color: $danger-color;
  font-size: 11px;
}

.nav-item{
    color: #626767 !important;
}


.add-user-icon-wrapper{
    height: 59px;
    width: 60px;
    line-height: 54px;
    margin: 0px auto;
    border-radius: 6px;
    background: $primary-background;
    color: $add-button-text-color;
    border: 1px solid $add-button-border-color; 
}

.add-user-icon-wrapper:hover{
    color: $add-button-text-color-hover;
    border: 1px solid $add-button-border-on-hover; 
}
.inactive:hover{
  color:$text-color !important;
}
.active{
    background: $primary-background !important;
    color:$active-blue  !important;
    border-bottom: 2px solid $active-blue ;
    font-weight: 500;
    font-size:15px;
}
.top-nav-bar{
    background: $primary-background;
}

.tags-display-ul .show-tags-delete{
  visibility:hidden;
}

.tags-display-ul li:hover .show-tags-delete{
  visibility: visible;
}

.editIcon{
  visibility:hidden;
}

.group-name:hover .editIcon{
  visibility: visible;
}

.show-tags-delete{
  position: relative;
  top: 2px;
}

.breadcrumb{
  padding: .75rem 1rem !important;
  background: $primary-background !important;
    .active-text-nav-bar{
        color: $text-color !important;
        text-decoration: none !important
    }
    .active-text-nav-bar:last-child{
            color: $active-blue !important;
            font-size:17px;
    }
    .breadcrumb-item{
        a{
            color: $text-color;
            font-weight:600;
        }
        a:hover{
            text-decoration: underline;
        }
    }    
}
.user-name-or-image{
    height: 60px;
    width: 60px;
    border: $border-color;
    border-radius: 10px;
    text-align: center;
    line-height: 56px;
    text-transform: uppercase;
    margin: 0 auto;
    font-size: 30px;
}

.delete-user-icon{
  visibility: hidden;
}

.comm-tags-class:hover .delete-user-icon{
  visibility: visible;
}

.delete-user-icon{
  position: absolute;
  inset-inline-end: 11px;
  top: -6px;
  height: 23px;
  width: 23px;
  border: $border-color;
  background: $secondary-background-color;
  border-radius: 30px;
  color: $text-color;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}

::v-deep {
  .multiselect__tag {
      background-color: $primary-background !important;
    }
    .multiselect__tags{
        background: $primary-background;
        border: $border-color;;
    }
    .multiselect__option--highlight {
        background: $bg-color-on-hover !important;
    }
    .multiselect__content {
        background: $secondary-background-color !important;
    }
    .multiselect__input, .multiselect__single {
        background: transparent !important;
        color:$text-color;
    }
    .multiselect__tag-icon{
       color:$text-color !important;
    }
    .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
        background: $bg-color-on-hover;
        color: $text-color !important;
    }
    .multiselect__tag-icon:after{
       color:$secondary-text-color !important;
       font-size: 23px;
    }
    .multiselect *{
        font-size: $input-field-and-label-font-size !important;
        font-family: "Roboto", Arial, sans-serif !important;
    }
    .multiselect{
      color:$text-color !important;
      font-size: $input-field-and-label-font-size !important;
      width:auto;
    }
    .multiselect__option--selected{
        background:  $bg-color-on-hover !important;
        color: $text-color;
    }
    .multiselect__content-wrapper{
        border: 1px solid  $bg-color-on-hover !important;
    }
    .multiselect__select,.multiselect__current,.multiselect__option{
        line-height: 12px !important;
    }
    .multiselect--above .multiselect__content-wrapper{
       background: $secondary-background-color !important;
    }
    .multiselect__tags {
        background: $primary-background;
    }
    .multiselect__input:focus{
      outline:none;
      box-shadow: none;
    }
}

.secondary-btn-style:hover{
  text-decoration: underline;
}
.secondary-btn-style{
  color:$text-color;
}
.primary-btn-style {
  margin-top: 1%;
  position: absolute;
  bottom: 8px;
  inset-inline-end: 0%;
  height:50px;
  background: $primary-background;
  width:100%;
  z-index:9;
  button {
    height: 38px;
    width: 70px;
    font-size:14px;
    margin-top:7px;
  }
  .btn-outline-secondary{
    float:inline-end;
  }
  .btn-outline-primary{
    margin-inline-end:15px;
  }
}

.manage-department-styles{
  float: inline-start;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  color: #909b43cf;
  width: 100%;
  text-align: end;
}

.manage-department-styles:hover{
  text-decoration: underline;
}

input[type="checkbox"]:after {
  line-height: 1.5em;
  content: "";
  display: inline-block !important;
  width: 22px !important;
  height: 21px !important;
  margin-top: -3px !important;
  margin-inline-start: -1px !important;
  border: $border-color !important;
  border-radius: 0.25em !important;
  background: $primary-background !important;
}
input[type="checkbox"]:checked:after {
  content: "✔";
  color: $active-blue !important;
  position: absolute !important;
  font-size: 16px !important;
  line-height: 1 !important;
  transition: all 0.2s !important;
  font-family: Helvetica, Arial, sans-serif;
  padding-inline-start: 4px !important;
  padding-top: 2px !important;
}


.selected-tags-style{
  background: $bg-color-on-hover;
  border: 1px solid #363636;
  border-radius: 15px;
  font-size: 12px !important;
  min-height: 25px !important;
  display: inline-flex !important;
  margin: 2px !important;
  border-radius: 15px !important;
  min-width: 50px !important;
  padding: 0px !important;
  text-align: center;
  width: auto !important;
  padding-inline-start: 12px !important;
  justify-content: center;
  padding-top: 2px !important;
  padding-inline-end: 4px !important;
  margin-bottom: 4px !important;
  .remove-tag{
      line-height:18px;
      color: #858585;
  }
  }

</style>